import { useQuery } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'

import api from '@/lib/api'

export function useFetchPermissionById(id_user?: string | undefined) {
  const token = useAccessToken()

  return useQuery({
    queryKey: ['permissions', id_user],
    queryFn: async () => {
      if (!id_user) throw new Error('ID da permissão não fornecido')
      try {
        const response = await api.get(`/permissions/${id_user}`, {
          headers: { Authorization: `Bearer ${token}` }
        })

        return response.data?.data
      } catch (error: any) {
        //  Se for erro do axios com resposta conhecida
        if (error.response && error.response.status === 404) {
          throw new Error(`Permissão com ID ${id_user} não encontrada`)
        }

        //  Outros erros (conexão, token expirado, etc)
        console.error('Erro ao buscar permissão:', error)
        throw new Error('Erro inesperado ao buscar permissão')
      }
    },
    enabled: Boolean(token && id_user)
  })
}
